import {Injectable}     from 'angular2/core';
import {Http, Response} from 'angular2/http';
import {Observable}     from 'rxjs/Observable';
import {Product}        from "../../models/product.model";
import {App}            from "../../app_config";

@Injectable()
export class ProductService {

    constructor(private http:Http) {
    }

    private _productUrl = App.AppConfig.apiEndPoint + '/products';

    getProducts(country:string):Observable<Product[]> {
        return this.http.get(this._productUrl + "/list/" + country)
            .map(this.extractData)
            .map(products => products.map(product => new Product(product)))
            .catch(this.handleError);
    }

    getProductsByIds(country:string, ids:string[]):Observable<string[]> {
        return this.http.get(this._productUrl + "/list/" + country + "/" + ids.join(","))
                .map(this.extractData)
                .map(products => products.map(product => new Product(product)))
                .catch(this.handleError);
    }

    private extractData(res:Response) {
        if (res.status < 200 || res.status >= 300) {
            throw new Error('Bad response status: ' + res.status);
        }
        let body = res.json();
        return body.products || {};
    }

    private handleError(error:any) {
        // In a real world app, we might send the error to remote logging infrastructure
        let errMsg = error.message || 'Server error';
        console.error(errMsg); // log to console instead
        return Observable.throw(errMsg);
    }
}
